module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hr-metrics-page"
  }, [_c('div', {
    staticClass: "dash-header"
  }, [_c('div', {
    staticClass: "dash-header-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dash-meta"
  }, _vm._l((_vm.metaRows), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "dash-meta-row"
    }, [_c('span', {
      staticClass: "dash-meta-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "dash-meta-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-chips"
  }, [_c('span', {
    staticClass: "dash-chip is-period"
  }, [_c('i', {
    staticClass: "chip-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "chip-label"
  }, [_vm._v("数据周期")]), _vm._v(" "), _c('Date-picker', {
    staticClass: "period-picker",
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "disabled": _vm.searchLoading,
      "transfer": "",
      "placeholder": "选择周期"
    },
    on: {
      "on-change": _vm.onPeriodChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.infoChips), function(chip) {
    return _c('span', {
      key: chip.label,
      staticClass: "dash-chip"
    }, [_c('i', {
      staticClass: "chip-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "chip-label"
    }, [_vm._v(_vm._s(chip.label))]), _vm._v(" "), _c('span', {
      staticClass: "chip-value"
    }, [_vm._v(_vm._s(chip.value))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标总览")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('Button', {
    staticClass: "dash-export",
    attrs: {
      "type": "primary",
      "loading": _vm.overviewExportLoading
    },
    on: {
      "click": _vm.exportOverview
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "kpi-dim-title"
  }, [_vm._v("老师维度")]), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [_c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.leaveRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('leaveRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('leaveRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.leaveRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.compareText))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("已通过请假的老师 + 老师缺席的老师 ÷ 有课老师 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.resignRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('resignRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('resignRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.resignRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.resignCompareText))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("离职人数 ÷ 月初在职人数 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.returnLessonHoursLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('returnLessonHours')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('returnLessonHours')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.returnLessonHoursText))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.returnLessonHoursCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("课堂投诉审核通过、外教课、赠课原因是老师 · 点击查看周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.refundStudentCountLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('refundStudentCount')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('refundStudentCount')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.refundStudentCountText))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.refundStudentCountCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("财务退费列表老师原因，按人去重 · 点击查看月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.demoAttendDealRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('demoAttendDealRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('demoAttendDealRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.demoAttendDealRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.demoAttendDealCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("demo成交学生数 ÷ demo出席学生数 · 点击查看月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.fullAttendanceRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('fullAttendanceRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('fullAttendanceRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.fullAttendanceRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.fullAttendanceCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("无老师迟到/早退/缺席/请假/离职的有课老师 ÷ 有课老师（不含学生请假、管理员取消、学生缺席且老师未缺席的课） · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.teacherLateRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('teacherLateRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('teacherLateRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.teacherLateRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.teacherLateCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("至少有一节迟到的正常上课老师 ÷ 有正常上课的老师。正常上课是已经上完，学生、老师都未缺席；一个老师只计一次 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.teacherEarlyRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('teacherEarlyRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('teacherEarlyRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.teacherEarlyRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.teacherEarlyCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("至少有一节早退的正常上课老师 ÷ 有正常上课的老师。正常上课是已经上完，学生、老师都未缺席；一个老师只计一次 · 点击查看日周月年")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "kpi-dim-title"
  }, [_vm._v("课节维度")]), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [_c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.attendLessonRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('attendLessonRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('attendLessonRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.attendLessonRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.attendLessonCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("已上课未缺席课节 ÷（买断课节 + 已上课临时课） · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.lessonLeaveRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('lessonLeaveRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('lessonLeaveRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.lessonLeaveRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.lessonLeaveCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("全部请假类型或老师缺席 ÷ 应上课课节 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.tempLeaveRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('tempLeaveRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('tempLeaveRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.tempLeaveRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.tempLeaveCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("（临时请假 + 失联 + 取消课或老师缺席）÷ 应上课课节 · 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.lateRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('lateRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('lateRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.lateRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.lateCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("老师迟到的课 ÷ 正常上课的课（已上完，学生、老师都未缺席；无通话按未缺席未迟到）· 点击查看日周月年")])])]), _vm._v(" "), _c('article', {
    staticClass: "kpi-card is-clickable",
    class: _vm.earlyRateLevel,
    on: {
      "click": function($event) {
        return _vm.openTrend('earlyRate')
      }
    }
  }, [_c('div', {
    staticClass: "kpi-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "kpi-body"
  }, [_c('a', {
    staticClass: "kpi-gear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openCardThreshold('earlyRate')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  })], 1), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.earlyRate))]), _vm._v(" "), _c('div', {
    staticClass: "kpi-period-row"
  }, [_c('span', {
    staticClass: "kpi-period"
  }, [_vm._v(_vm._s(_vm.periodText))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-compare"
  }, [_vm._v(_vm._s(_vm.earlyCompare))])]), _vm._v(" "), _c('p', {
    staticClass: "kpi-foot"
  }, [_vm._v("老师早退的课 ÷ 正常上课的课（已上完，学生、老师都未缺席；无通话按未缺席未早退）· 点击查看日周月年")])])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.editCardTitle,
      "width": "520",
      "mask-closable": false,
      "loading": _vm.saveLoading
    },
    on: {
      "on-ok": _vm.saveThresholds
    },
    model: {
      value: (_vm.showThresholdModal),
      callback: function($$v) {
        _vm.showThresholdModal = $$v
      },
      expression: "showThresholdModal"
    }
  }, [_c('p', {
    staticClass: "threshold-tip"
  }, [_vm._v(_vm._s(_vm.editCardHint))]), _vm._v(" "), _c('div', {
    staticClass: "threshold-row"
  }, [_c('span', {
    staticClass: "threshold-label"
  }, [_vm._v("方向")]), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.editDirection),
      callback: function($$v) {
        _vm.editDirection = $$v
      },
      expression: "editDirection"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "worse"
    }
  }, [_vm._v("越小越健康")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "better"
    }
  }, [_vm._v("越大越健康")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "threshold-row"
  }, [_c('span', {
    staticClass: "threshold-field"
  }, [_c('span', {
    staticClass: "threshold-label"
  }, [_vm._v("健康")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 999999
    },
    model: {
      value: (_vm.editBand.healthy),
      callback: function($$v) {
        _vm.$set(_vm.editBand, "healthy", $$v)
      },
      expression: "editBand.healthy"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "threshold-unit"
  }, [_vm._v(_vm._s(_vm.editCardUnit))])], 1), _vm._v(" "), _c('span', {
    staticClass: "threshold-field"
  }, [_c('span', {
    staticClass: "threshold-label"
  }, [_vm._v("需关注")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 999999
    },
    model: {
      value: (_vm.editBand.attention),
      callback: function($$v) {
        _vm.$set(_vm.editBand, "attention", $$v)
      },
      expression: "editBand.attention"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "threshold-unit"
  }, [_vm._v(_vm._s(_vm.editCardUnit))])], 1), _vm._v(" "), _c('span', {
    staticClass: "threshold-field"
  }, [_c('span', {
    staticClass: "threshold-label"
  }, [_vm._v("预警")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 999999
    },
    model: {
      value: (_vm.editBand.alert),
      callback: function($$v) {
        _vm.$set(_vm.editBand, "alert", $$v)
      },
      expression: "editBand.alert"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "threshold-unit"
  }, [_vm._v(_vm._s(_vm.editCardUnit))])], 1)])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.trendModalTitle,
      "width": _vm.trendModalWidth,
      "mask-closable": true
    },
    on: {
      "on-visible-change": _vm.onTrendVisible
    },
    model: {
      value: (_vm.showTrendModal),
      callback: function($$v) {
        _vm.showTrendModal = $$v
      },
      expression: "showTrendModal"
    }
  }, [(!_vm.showDetail) ? _c('div', [_c('div', {
    staticClass: "trend-toolbar"
  }, [_c('Radio-group', {
    attrs: {
      "type": "button",
      "disabled": _vm.trendLoading
    },
    on: {
      "on-change": _vm.searchTrend
    },
    model: {
      value: (_vm.trendPeriodType),
      callback: function($$v) {
        _vm.trendPeriodType = $$v
      },
      expression: "trendPeriodType"
    }
  }, _vm._l((_vm.trendPeriodOptions), function(item) {
    return _c('Radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1), _vm._v(" "), _c('Date-picker', {
    staticClass: "trend-picker",
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "disabled": _vm.trendLoading,
      "transfer": "",
      "placeholder": "选择周期"
    },
    on: {
      "on-change": _vm.onTrendPeriodChange
    },
    model: {
      value: (_vm.trendDateRange),
      callback: function($$v) {
        _vm.trendDateRange = $$v
      },
      expression: "trendDateRange"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-adviser trend-adviser"
  }, [_c('span', {
    staticClass: "detail-adviser-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('Select', {
    staticClass: "detail-adviser-select",
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "disabled": _vm.trendLoading
    },
    on: {
      "on-change": _vm.onTrendStudyAdviserChange
    },
    model: {
      value: (_vm.trendStudyAdviserId),
      callback: function($$v) {
        _vm.trendStudyAdviserId = _vm._n($$v)
      },
      expression: "trendStudyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n            ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "trend-tip"
  }, [_vm._v(_vm._s(_vm.trendHint))]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.trendColumns,
      "data": _vm.trendTableData,
      "loading": _vm.trendLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), (_vm.trendMetric === 'fullAttendanceRate') ? _c('div', {
    staticClass: "non-full-block"
  }, [_c('div', {
    staticClass: "non-full-head"
  }, [_c('h4', {
    staticClass: "non-full-title"
  }, [_vm._v("未全勤老师")]), _vm._v(" "), _c('Input', {
    staticClass: "non-full-search",
    attrs: {
      "clearable": "",
      "placeholder": "老师ID / 姓名"
    },
    on: {
      "on-enter": _vm.onNonFullKeywordSearch,
      "on-clear": _vm.onNonFullKeywordSearch
    },
    model: {
      value: (_vm.nonFullKeyword),
      callback: function($$v) {
        _vm.nonFullKeyword = $$v
      },
      expression: "nonFullKeyword"
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.nonFullLoading
    },
    on: {
      "click": _vm.onNonFullKeywordSearch
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('p', {
    staticClass: "trend-tip"
  }, [_vm._v("该日期范围内有老师责任异常课节的老师。学生请假、管理员取消、学生缺席且老师未迟到早退缺席的课不计入。点异常课节数查看具体课节。")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.nonFullColumns,
      "data": _vm.nonFullTableData,
      "loading": _vm.nonFullLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "trend-page"
  }, [_c('Page', {
    attrs: {
      "total": _vm.nonFullTotal,
      "current": _vm.nonFullPageIndex,
      "page-size": _vm.nonFullPageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onNonFullPageChange,
      "on-page-size-change": _vm.onNonFullPageSizeChange
    }
  })], 1)], 1) : _vm._e()], 1) : _c('div', [_c('div', {
    staticClass: "trend-nav"
  }, [_c('a', {
    staticClass: "trend-back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backToTrend.apply(null, arguments)
      }
    }
  }, [_vm._v("返回区间表")]), _vm._v(" "), _c('span', {
    staticClass: "trend-crumb"
  }, [_vm._v(_vm._s(_vm.detailTitle))])]), _vm._v(" "), _c('p', {
    staticClass: "trend-tip"
  }, [_vm._v(_vm._s(_vm.detailHint))]), _vm._v(" "), _c('div', {
    staticClass: "detail-adviser"
  }, [_c('span', {
    staticClass: "detail-adviser-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('Select', {
    staticClass: "detail-adviser-select",
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onDetailStudyAdviserChange
    },
    model: {
      value: (_vm.detailStudyAdviserId),
      callback: function($$v) {
        _vm.detailStudyAdviserId = _vm._n($$v)
      },
      expression: "detailStudyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.detailColumns,
      "data": _vm.detailTableData,
      "loading": _vm.detailLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "trend-page"
  }, [_c('Page', {
    attrs: {
      "total": _vm.detailTotal,
      "current": _vm.detailPageIndex,
      "page-size": _vm.detailPageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onDetailPageChange,
      "on-page-size-change": _vm.onDetailPageSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportCurrent
    }
  }, [_vm._v("导出")]), _vm._v(" "), (_vm.showDetail) ? _c('Button', {
    on: {
      "click": _vm.backToTrend
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeTrendModal
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('user-info-modal', {
    attrs: {
      "value": _vm.showUserInfoModal,
      "uid": _vm.userInfoUid
    },
    on: {
      "on-close": function($event) {
        _vm.showUserInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-header-left"
  }, [_c('h1', {
    staticClass: "dash-title"
  }, [_vm._v("外教核心数据看板")]), _vm._v(" "), _c('p', {
    staticClass: "dash-sub"
  }, [_vm._v("\n          Foreign Teacher HR Core Metrics Dashboard - 出勤履约 / 人员稳定 / 服务质量 / 成本效益\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-filters"
  }, [_c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("健康\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("需关注\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("预警\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 同比口径：—")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            请假率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            离职率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            返课时数\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            退费学生数\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            Demo出席成交率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            全勤率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            迟到率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            早退率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            上课率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            请假率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            临时请假率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            迟到率\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi-title"
  }, [_c('i', {
    staticClass: "kpi-dot"
  }), _vm._v("\n            早退率\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-add373d8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchHrMetricsDashboard.vue
// module id = 1947
// module chunks = 8